import { ReactSVG } from 'react-svg';
import styled, { css } from 'styled-components';

// ** Components
import { Image } from 'components';

// ** Utils
import { pxToRem } from 'utils/transform-px.utils';

// ** Utils
import { StyledHorizontalLineItem } from 'styles/figure.styled';

export const PartnerStyled = styled.div`
  position: relative;
  height: ${pxToRem(664)};
  padding: ${pxToRem(80)} ${pxToRem(209)} ${pxToRem(80)} ${pxToRem(93)};
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  align-items: flex-start;
  &:after {
    content: '';
    ${StyledHorizontalLineItem};
    left: -${pxToRem(59)};
    width: ${pxToRem(29)};
  }
  ${(props) =>
    props.theme.media.down(
      'md',
      css`
        height: ${pxToRem(545)};
        padding: ${pxToRem(77)} ${pxToRem(437)} ${pxToRem(77)} ${pxToRem(77)};
        &:after {
          display: none;
        }
      `
    )}
  ${(props) =>
    props.theme.media.down(
      'sm',
      css`
        height: auto;
        padding: ${pxToRem(50)} ${pxToRem(35)};
        &:after {
          display: block;
          width: ${pxToRem(19)};
          left: -${pxToRem(35)};
        }
      `
    )}
`;

export const StyledInner = styled.div`
  width: 100%;
  height: 100%;
  position: absolute;
  top: 0;
  left: 0;
  z-index: -1;
  background: ${(props) => props.theme.color.black};
`;

export const StyledImage = styled(Image)`
  width: 100%;
  height: 100%;
`;

export const StyledContent = styled.div`
  color: ${(props) => props.theme.color.white};
  margin: ${pxToRem(20)} 0;
  max-width: ${pxToRem(938)};
`;

export const StyledLogoPNG = styled.img<{ $logoHeight: number, $mobileHeight: number }>`
  // width: fit-content;
    object-fit: contain;
    min-height: ${(props) => pxToRem(props.$logoHeight)};
    height: ${(props) => pxToRem(props.$logoHeight)};
    ${(props) =>
            props.theme.media.down(
                    'md',
                    css`
                      min-height: auto;
                      height: ${pxToRem(props.$logoHeight * 0.62)};
      `
            )};
    ${(props) =>
            props.theme.media.down(
                    'sm',
                    css`
                      min-height: auto;
                      height: ${pxToRem(props.$mobileHeight)};
      `
            )}; 
`;

export const StyledLogo = styled(ReactSVG)<{ $logoHeight: number, $mobileHeight: number }>`
  div,
  svg {
    //width: fit-content;
    object-fit: contain;
    height: ${(props) => pxToRem(props.$logoHeight)};
    ${(props) =>
      props.theme.media.down(
        'md',
        css`
          height: ${pxToRem(props.$logoHeight * 0.62)};
        `
      )};
    ${(props) =>
      props.theme.media.down(
        'sm',
        css`
          height: ${pxToRem(props.$mobileHeight)};
        `
      )};
  }
`;
